import {useContext} from 'react';

import PwaContext from '../../contexts/PwaContext';

const usePwa = () => {
  return useContext(PwaContext);
};

export default usePwa;
